/**
 * @generated SignedSource<<e9ea9aaa0b0e726ccb5b57aa5fa2fc01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutAddCreditCard_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardForm_buyer">;
  readonly " $fragmentType": "CheckoutAddCreditCard_buyer";
};
export type CheckoutAddCreditCard_buyer$key = {
  readonly " $data"?: CheckoutAddCreditCard_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAddCreditCard_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutAddCreditCard_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardForm_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9a62d947e877d04a5648ca71dc43ba9d";

export default node;
